import { Compass, PenTool, Zap, LineChart } from "lucide-react";

const ACCENT = "#BEF264";

const NODES = [
  { Icon: Compass, label: "Strategy" },
  { Icon: PenTool, label: "Creation" },
  { Icon: Zap, label: "Automation" },
  { Icon: LineChart, label: "Measurement" },
];

const EXPERTISE = [
  "Website & landing-page creation", "Digital marketing", "CRM", "Sales processes", "Email automation", "Analytics & attribution",
];

export default function SalesWhy() {
  return (
    <section id="why-rekisa" aria-labelledby="why-rekisa-heading" data-testid="web-benefits-why-section" className="relative py-20 sm:py-28 bg-white overflow-hidden">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-zinc-50 px-3.5 py-1.5 text-[11px] tracking-[0.14em] uppercase text-zinc-600 font-semibold mb-6">
              <span className="h-1.5 w-1.5 rounded-full" style={{ background: "#0B1120" }} /> Website development company South Africa
            </div>
            <h2 id="why-rekisa-heading" className="font-display text-4xl sm:text-5xl font-black tracking-[-0.03em] leading-[1.04] text-zinc-900">
              Website Creation, CRM and Growth Marketing Expertise in One Implementation
            </h2>
            <p className="mt-5 text-zinc-600 leading-relaxed">
              Rekisa combines website creation, digital marketing, CRM, sales processes and automation to help South African
              businesses improve how they attract and manage customers.
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {EXPERTISE.map((e) => (
                <span key={e} className="rounded-full border border-zinc-200 bg-zinc-50 px-3 py-1 text-[12px] font-semibold text-zinc-700">{e}</span>
              ))}
            </div>
            <p className="mt-6 text-zinc-600 leading-relaxed text-sm">
              Our approach starts with the customer's journey and the business outcome, not simply the website design. We help
              businesses define what customers should do, what information should be captured and how the sales team should respond.
            </p>
          </div>

          {/* ecosystem graphic */}
          <div className="relative aspect-square max-w-md mx-auto w-full">
            <div className="absolute inset-0 rounded-3xl bg-sales-navy border border-white/10" />
            {/* center */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-28 w-28 rounded-2xl flex flex-col items-center justify-center text-center" style={{ background: ACCENT }}>
                <span className="text-[10px] font-bold uppercase tracking-wider text-[#0B1120]/70">Rekisa</span>
                <span className="font-display text-base font-black text-[#0B1120] leading-tight">Sales<br/>System</span>
              </div>
            </div>
            {/* nodes */}
            {NODES.map(({ Icon, label }, i) => {
              const pos = [
                "top-6 left-6", "top-6 right-6", "bottom-6 left-6", "bottom-6 right-6",
              ][i];
              return (
                <div key={label} className={`absolute ${pos} w-28`}>
                  <div className="rounded-xl border border-white/10 bg-white/[0.06] backdrop-blur p-3 text-center">
                    <div className="h-8 w-8 rounded-lg mx-auto flex items-center justify-center bg-white/[0.08]">
                      <Icon className="h-4 w-4" style={{ color: ACCENT }} />
                    </div>
                    <div className="mt-2 text-[11px] font-bold text-white">{label}</div>
                  </div>
                </div>
              );
            })}
            {/* connectors */}
            <svg className="absolute inset-0 w-full h-full" aria-hidden>
              <line x1="22%" y1="22%" x2="50%" y2="50%" stroke={ACCENT} strokeWidth="1" strokeOpacity="0.35" />
              <line x1="78%" y1="22%" x2="50%" y2="50%" stroke={ACCENT} strokeWidth="1" strokeOpacity="0.35" />
              <line x1="22%" y1="78%" x2="50%" y2="50%" stroke={ACCENT} strokeWidth="1" strokeOpacity="0.35" />
              <line x1="78%" y1="78%" x2="50%" y2="50%" stroke={ACCENT} strokeWidth="1" strokeOpacity="0.35" />
            </svg>
          </div>
        </div>

      </div>
    </section>
  );
}
